import React from 'react'
import PropTypes from 'prop-types'
import LoadingBar from '@boltui/loading-bar'

import styles from './LoadingProgressBar.scss'

const LoadingProgressBar = ({ loading = false }) => (
  <div className={styles['loading-bar']}>
    <LoadingBar loading={loading} />
  </div>
)

LoadingProgressBar.propTypes = {
  loading: PropTypes.bool,
}

export default LoadingProgressBar
